import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

// * Import custom component

// * Import kits
import Box from "../../kit/Box";
import Button from "../../kit/Button";

// * Import data
import function_img_light from "../../../assets/images/signup_images/light_theme/function_img.svg";
import function_img_dark from "../../../assets/images/signup_images/dark_theme/function_img_dark.svg";

import FunctionsCard from "./FunctionsCard";

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import { getThemeName } from "../../utils/utils";

// * Import utils

// # Components
const FunctionsInfo = ({
  setActiveScreen,
  templateData,
  activeStep,
  setActiveStep,
}) => {
  const theme = useTheme();
  const classes = accountSetupStyles(theme);

  const selectedFunctions =
    useSelector((state) => state.accountSetup.functions) || [];

  const handleBack = () => {
    setActiveScreen((prev) => prev - 1);
    setActiveStep(activeStep - 1);
  };

  const handleNext = () => {
    setActiveScreen((prev) => prev + 1);
    setActiveStep(activeStep + 1);
  };
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const function_img = getThemeName(isDarkMode)
    ? function_img_dark
    : function_img_light;

  // # JSX
  return (
    <div
      className={classes.setupCardContainer}
      style={{ height: "100%", display: "flex", flexDirection: "row" }}
    >
      <Box className={classes.container} sx={{ alignItems: "center" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "calc(100vh - 50px)%",
            overflow: "auto",
            paddingBottom: theme.size[50],
            width: "fit-content",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              position: "absolute",
              top: "200px",
            }}
          >
            <FunctionsCard
              templateData={templateData}
              selectedFunctions={selectedFunctions}
            />
          </div>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              position: "absolute",
              bottom: theme.size[30],
              background: theme.palette.tertiary.light,
              zIndex: "1000",
              padding: "20px 5px 0 23rem",
            }}
          >
            <Button
              disableRipple
              className={classes.accountSetupButtonOutlined}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              disableRipple
              className={classes.accountSetupButtonFilled}
              onClick={handleNext}
              disabled={!selectedFunctions?.length}
            >
              Next
            </Button>
          </Box>
        </div>
      </Box>
      <Box sx={{ height: "100%", width: "40%", position: "relative" }}>
        <img
          src={function_img}
          alt="error"
          style={{ height: "100%", position: "absolute", right: "-60px" }}
        />
      </Box>
    </div>
  );
};

export default FunctionsInfo;
